import { Button } from '@repo/ui/components/button';
import { Link } from '@tanstack/react-router';
import { CheckCircle, Mail } from 'lucide-react';

interface MagicLinkSentProps {
  email: string;
  onTryAgain: () => void;
}

export function MagicLinkSent({ email, onTryAgain }: MagicLinkSentProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-6 text-center">
        <div className="bg-primary/10 mx-auto flex h-16 w-16 items-center justify-center rounded-full">
          <CheckCircle className="text-primary h-8 w-8" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            Verifique seu email
          </h1>
          <p className="text-muted-foreground text-sm">
            Enviamos um link de acesso para{' '}
            <span className="text-foreground font-medium">{email}</span>
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Mail className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
            <p className="text-muted-foreground text-left text-sm">
              Clique no link enviado para seu email para entrar na sua conta e
              aceitar o convite. O link expira em 10 minutos.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3 text-center">
        <Button variant="outline" onClick={onTryAgain} className="w-full">
          Usar outro email
        </Button>
        <Link
          to="/"
          className="text-muted-foreground hover:text-primary block text-sm"
        >
          Voltar para a página inicial
        </Link>
      </div>
    </div>
  );
}
